import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Application } from 'src/app/shared/models/Application.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationService } from 'src/app/shared/services/application.service';

@Component({
  selector: 'app-detailed-application-info',
  templateUrl: './detailed-application-info.component.html',
  styleUrls: ['./detailed-application-info.component.css'],
})
export class DetailedApplicationInfoComponent implements OnInit {
  @Input() application: Application;
  @Output() formChange: EventEmitter<Application> =
    new EventEmitter<Application>();
  @Output() fileUpdate: EventEmitter<Application> =
    new EventEmitter<Application>();

  isCollapsed = true;
  detailedInfoForm: FormGroup;
  attachmentEditForm: FormGroup;
  files: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private ngbModal: NgbModal,
    private applicationService: ApplicationService
  ) {
    this.detailedInfoForm = this.formBuilder.group({
      Id: ['', []],
      Admin: ['', []],
      Status: ['', []],
      Comment: ['', []],
    });
  }

  ngOnInit(): void {
    this.getFilesForApplication();
  }

  getFilesForApplication() {
    console.log('getfiles');

    this.applicationService
      .getFilesById(this.application.Id)
      .subscribe((res) => (this.files = res));
  }

  onOpenAttachment(attachment: string) {
    var base64 = attachment.split(',');
    var byteCharacters = atob(base64[1]);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: base64[0].replace('data:', '') });
    var fileURL = URL.createObjectURL(file);

    window
      .open()
      .document.write(
        "<iframe width='100%' height='100%' style='border:none;' src='" +
          encodeURI(fileURL) +
          "'></iframe>"
      );
  }

  onCloseModal() {
    this.getFilesForApplication();
    this.fileUpdate.emit();
  }

  onOpenModal(content) {
    this.ngbModal.open(content, { centered: true });
  }

  onSubmit(applicationObject: Application) {
    applicationObject.Status = this.detailedInfoForm.value.Status;
    applicationObject.Admin = this.detailedInfoForm.value.Admin;
    applicationObject.Comment = this.detailedInfoForm.value.Comment;
    this.formChange.emit(applicationObject);
  }
}
